import script from "./SubCategoryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubCategoryItem.vue?vue&type=script&setup=true&lang=ts"

import "./SubCategoryItem.vue?vue&type=style&index=0&id=66a87292&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a87292"]])

export default __exports__